<template>
  <div>
    <div v-if="show" tabindex="-1"
      class="overflow-y-auto overflow-x-hidden fixed top-1/3 right-0 left-0 z-50  h-modal ">
      <div class="relative p-4 w-full max-w-md h-full md:h-auto">
        <div class="relative bg-white rounded-lg shadow-lg dark:bg-gray-700">
          <div class="p-6 text-center">
            <div class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-primary"
              role="status">
              <!-- <span class="visually-hidden">Loading...</span> -->
            </div>
            <h3 class="my-5 font-normal text-primary font-bold text-20">
              Be Patient!!
            </h3>

            <p> We’re processing the information</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bgColor: "#DB8633",
    }
  },
  computed: {
    show() {
      return this.$getState("isLoaderModal");
    }
  },
  watch: {
    show (flag) {
      this.$setState('setLoader', flag ? 1 : 0)
    }
  }
}
</script>